/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  NewIntroductionPayload,
  SendIntroduction200,
  UpdateIntroductionStatusResponse,
  UpdateStatusBody,
} from './platformapi.schemas';

import sendIntroductionMutator from '../custom-axios-instance';
import updateStatusMutator from '../custom-axios-instance';

/**
 * Sends an introduction from the current user to the target user.
 * @summary Send Introduction
 */
export const sendIntroduction = (
  targetUserId: number,
  newIntroductionPayload: NewIntroductionPayload,
  signal?: AbortSignal,
) => {
  return sendIntroductionMutator<SendIntroduction200>({
    url: `${import.meta.env['VITE_API_HOST']}/introductions/send_introduction/${targetUserId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: newIntroductionPayload,
    signal,
  });
};

export const getSendIntroductionMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendIntroduction>>,
    TError,
    { targetUserId: number; data: NewIntroductionPayload },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendIntroduction>>,
  TError,
  { targetUserId: number; data: NewIntroductionPayload },
  TContext
> => {
  const mutationKey = ['sendIntroduction'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendIntroduction>>,
    { targetUserId: number; data: NewIntroductionPayload }
  > = (props) => {
    const { targetUserId, data } = props ?? {};

    return sendIntroduction(targetUserId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendIntroductionMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendIntroduction>>
>;
export type SendIntroductionMutationBody = NewIntroductionPayload;
export type SendIntroductionMutationError = void | HTTPValidationError;

/**
 * @summary Send Introduction
 */
export const useSendIntroduction = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendIntroduction>>,
      TError,
      { targetUserId: number; data: NewIntroductionPayload },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendIntroduction>>,
  TError,
  { targetUserId: number; data: NewIntroductionPayload },
  TContext
> => {
  const mutationOptions = getSendIntroductionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * API to accept or decline a pending introduction
 * @summary Update Status
 */
export const updateStatus = (updateStatusBody: UpdateStatusBody, signal?: AbortSignal) => {
  return updateStatusMutator<UpdateIntroductionStatusResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/introductions/update_status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateStatusBody,
    signal,
  });
};

export const getUpdateStatusMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStatus>>,
    TError,
    { data: UpdateStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStatus>>,
  TError,
  { data: UpdateStatusBody },
  TContext
> => {
  const mutationKey = ['updateStatus'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStatus>>,
    { data: UpdateStatusBody }
  > = (props) => {
    const { data } = props ?? {};

    return updateStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateStatus>>>;
export type UpdateStatusMutationBody = UpdateStatusBody;
export type UpdateStatusMutationError = void | HTTPValidationError;

/**
 * @summary Update Status
 */
export const useUpdateStatus = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStatus>>,
      TError,
      { data: UpdateStatusBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateStatus>>,
  TError,
  { data: UpdateStatusBody },
  TContext
> => {
  const mutationOptions = getUpdateStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
